import { Component, Input, OnInit } from '@angular/core';
import { IconService } from "../../providers/service/icon.service";
import { MachineCardLayoutEnum, MachineElement } from "../../ParseClass/environment-element";
import {
    arrayIsSet,
    isValidDate,
    KeyStringValue,
    objectIsSet,
    SENSORDATATYPETYPEVALUE,
    stringIsSet
} from "../../providers/service/global-variables.service";
import { TranslateService } from "@ngx-translate/core";
import { CustomDatePipe } from "../../providers/pipes/custom-date.pipe";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: 'app-box-industry-machines',
    templateUrl: './box-industry-machines.component.html',
    styleUrls: ['./box-industry-machines.component.scss'],
    standalone: false
})
export class BoxIndustryMachinesComponent implements OnInit {
    @Input() industryMachine: MachineElement | undefined
    @Input() layout: any
    @Input() showBottom = false;

    public machineCardLayout = MachineCardLayoutEnum;
    getDate$: (date: Date) => Observable<string>;
    getTraduction: (value: string, params: KeyStringValue<string>) => string;

    constructor(iconService: IconService,
        ts: TranslateService
    ) {
        iconService.addSvgIcon('prova', 'assets/icon/industry/pump.svg')
        iconService.addSvgIcon('flame', 'assets/icon/energy/flame.svg')
        iconService.addSvgIcon('portata', 'assets/icon/button/portata.svg')
        iconService.addSvgIcon('resistor', 'assets/icon/button/resistor.svg')
        iconService.addSvgIcon('luminosity', 'assets/icon/button/luminosity.svg')
        iconService.addSvgIcon('TANK_LEVEL', 'assets/icon/button/tankLevel.svg')
        iconService.addSvgIcon('bolt', 'assets/icon/button/bolt.svg')
        iconService.addSvgIcon('thermometer', 'assets/icon/button/thermometer.svg')
        iconService.addSvgIcon('frequency', 'assets/icon/button/frequency.svg')
        this.getDate$ = (date) => {
            if (date == null) {
                return of(ts.instant('NaN'))
            } else {
                return new CustomDatePipe(ts).transform(date, 'medium')
            }
        }
        this.getTraduction = (value, params) => {
            return ts.instant(value, params)
        }
    }

    ngOnInit() {
    }

    getValueByLayoutPredicate(machine: MachineElement): {
        cardLayout: MachineCardLayoutEnum,
        mainValue?: any,
        secondaryValues?: {
            cssBorderColorClass: string,
            cssTextColorClass: string,
            value: string,
            traductionKey: string
        }[],
        name?: string,
        templateValues: KeyStringValue<any>
    } {

        let cardLayout = machine.cardLayout!;
        const getMainValue = (info: any, key: string): {
            int: number,
            decimal: number,
            traductionKey?: string
        } | undefined => {
            if (info && info[key] != null) {
                const value = info[key];
                let int = Math.trunc(value);
                let decimal = isFinite(int) ? Math.round((value - int) * 10) : 0;
                if (decimal >= 10) {
                    int = int + 1
                    decimal = 0;
                }
                const traductionKey = key;
                const mainValue = { int, decimal, traductionKey };
                if (!isFinite(mainValue.int)) {
                    mainValue.int = 0;
                }
                return mainValue;
            } else {
                return undefined;
            }
        }
        const getSecondaryValues = (machine: MachineElement, info: any): {
            cssBorderColorClass: string,
            cssTextColorClass: string,
            value: string,
            traductionKey: string
        }[] | undefined => {
            if (arrayIsSet(machine.secondaryInfoKeys) && info != null) {
                return machine.secondaryInfoKeys.reduce((prev, currentKey, index) => {
                    if (currentKey in info && info[currentKey] != null) {
                        if (prev == null) {
                            prev = [];
                        }
                        const cssBorderColorClasses = ['border-color-primary', 'border-color-accent']
                        const cssBorderColorClass = cssBorderColorClasses[(prev.length % cssBorderColorClasses.length)]
                        const cssTextColorClasses = ['text-color-primary', 'text-color-accent']
                        const cssTextColorClass = cssTextColorClasses[(prev.length % cssTextColorClasses.length)]
                        prev.push({
                            cssBorderColorClass,
                            cssTextColorClass,
                            value: info[currentKey],
                            traductionKey: currentKey,
                        });
                    }
                    return prev;
                }, undefined as any)
            } else {
                return undefined;
            }
        }
        const keysAnimation = [
            MachineCardLayoutEnum.PUMP,
            MachineCardLayoutEnum.MIXER,
            MachineCardLayoutEnum.COMPRESSOR,
        ]
        let name;
        let mainValue;
        let secondaryValues;
        let templateValues = {};
        if (machine.cardLayout == MachineCardLayoutEnum.VALVE) {
            name = machine.name;
            const info = machine.info;
            const mainInfoKey = machine.mainInfoKey as keyof typeof info
            const isLoad = info ? info.IS_OPEN : false
            templateValues = { name: machine.name, isLoad }
            if (objectIsSet(info)) {
                if (stringIsSet(mainInfoKey) && (mainInfoKey in info)) {
                    const percentage = Math.round(info[mainInfoKey]);
                    mainValue = percentage + '%'
                } else if (machine.info.IS_OPEN && machine.info.IS_CLOSE) {
                    mainValue = '50%'
                } else if (machine.info.IS_OPEN && !machine.info.IS_CLOSE) {
                    mainValue = '100%'
                } else {
                    mainValue = '0%'
                }
            } else {
                mainValue = '0%'
            }
        } else if (machine.cardLayout == MachineCardLayoutEnum.SWITCH) {
            name = machine.name;
            const info = machine.info;
            const isLoad = objectIsSet(info) ? info.IS_ON : false
            templateValues = { name: machine.name, isLoad }
        } else if (machine.cardLayout == MachineCardLayoutEnum.TANK) {
            name = machine.name;
            const isLoad = machine.info != null
            let level
            let keyTraduction
            if (machine.info && machine.info[machine.mainInfoKey!]) {
                level = Math.round(machine.info[machine.mainInfoKey!] * 100) / 100
                keyTraduction = machine.mainInfoKey
            }
            templateValues = { name: machine.name, isLoad, level, keyTraduction }
        } else if (machine.cardLayout == MachineCardLayoutEnum.COMPRESSOR) {
            name = machine.name;
            console.log(machine)
            const isLoad = machine.info != null
            let level
            let keyTraduction
            if (machine.info && machine.info[machine.mainInfoKey!]) {
                level = Math.round(machine.info[machine.mainInfoKey!] * 100) / 100
                keyTraduction = machine.mainInfoKey
            }
            templateValues = { name: machine.name, isLoad, level, keyTraduction }
        } else if (keysAnimation.includes(machine.cardLayout!) && objectIsSet(machine.info) && arrayIsSet(machine.secondaryInfoKeys)) {
            const isLoad = machine.secondaryInfoKeys.findIndex(key => {
                if (key in machine.info) {
                    if (typeof (machine.info)[key] == "boolean") {
                        return (machine.info)[key] as any == true;
                    } else if (typeof (machine.info)[key] == "number") {
                        return (machine.info)[key] != 0;
                    } else {
                        return (machine.info)[key] != null;
                    }
                }
                return false;
            }) >= 0;
            templateValues = { isLoad };
            name = machine.name
        } else {
            name = machine.name
        }
        const obj = {
            cardLayout,
            mainValue,
            name,
            secondaryValues,
            templateValues
        }
        return obj
    }

    getValueByLayoutPredicate_v2(machine: MachineElement): {
        cardLayout: MachineCardLayoutEnum,
        mainValue?: any,
        secondaryValues?: {
            cssBorderColorClass: string,
            cssTextColorClass: string,
            value: string,
            traductionKey: string
        }[],
        name?: string,
        templateValues: KeyStringValue<any>
    } {

        let cardLayout = machine.cardLayoutWidthSpecial!;
        const name = machine.name;
        let templateValues = {};
        let showButtomValue = false
        const keysWithIcon = [MachineCardLayoutEnum.GENERIC_IMAGE_1, MachineCardLayoutEnum.VALVE, MachineCardLayoutEnum.SWITCH, MachineCardLayoutEnum.TANK, MachineCardLayoutEnum.COMPRESSOR, MachineCardLayoutEnum.MIXER, MachineCardLayoutEnum.PUMP]

        if (cardLayout == MachineCardLayoutEnum.GENERIC_IMAGE_1) {
            showButtomValue = true
            let isLoad = false
            const isOnValue = machine.getValueForType('IS_OPEN')
            if (isOnValue) {
                isLoad = isOnValue.value > 0
            } else if (machine.mainInfoKey != null) {
                isLoad = Boolean(machine.getValueForType(machine.mainInfoKey)?.value);
            }
            templateValues = { name: machine.name, isLoad }
        } else if (cardLayout == MachineCardLayoutEnum.VALVE) {
            showButtomValue = true
            let isLoad = false
            const isOnValue = machine.getValueForType('IS_OPEN')
            if (isOnValue) {
                isLoad = isOnValue.value > 0
            } else if (machine.mainInfoKey != null) {
                isLoad = Boolean(machine.getValueForType(machine.mainInfoKey)?.value);
            }
            templateValues = { name: machine.name, isLoad }
        } else if (cardLayout == MachineCardLayoutEnum.SWITCH) {
            showButtomValue = true
            let isLoad = false
            const isOnValue = machine.getValueForType('IS_ON')
            if (isOnValue) {
                isLoad = isOnValue.value > 0
            }
            templateValues = { name: machine.name, isLoad }
        } else if (cardLayout == MachineCardLayoutEnum.TANK) {
            showButtomValue = true
            const isLoad = arrayIsSet(machine.secondaryValues)
            const levelValue = machine.getValueForType(machine.mainInfoKey!)
            let level
            let keyTraduction
            if (levelValue) {
                level = levelValue.value
                keyTraduction = machine.mainInfoKey
            }
            templateValues = { name: machine.name, isLoad, level, keyTraduction }
        } else if (cardLayout == MachineCardLayoutEnum.COMPRESSOR) {
            showButtomValue = true
            let isLoad = false
            const isOnValue = machine.getValueForType('IS_ON')
            if (isOnValue) {
                isLoad = isOnValue.value > 0
            }
            templateValues = { name: machine.name, isLoad }
        } else if (cardLayout == MachineCardLayoutEnum.MIXER) {
            showButtomValue = true
            let isLoad = false
            const isOnValue = machine.getValueForType('IS_ON')
            if (isOnValue) {
                isLoad = isOnValue.value > 0
            }
            templateValues = { name: machine.name, isLoad }
        } else if (cardLayout == MachineCardLayoutEnum.PUMP) {
            showButtomValue = true
            let isLoad = false
            const isOnValue = machine.getValueForType('IS_ON')
            if (isOnValue) {
                isLoad = isOnValue.value > 0
            }
            templateValues = { name: machine.name, isLoad }
        }
        const getGridContainerClass = () => {
            const secondaryValues = machine.secondaryValues;
            if (!arrayIsSet(secondaryValues) && !keysWithIcon.includes(cardLayout!)) {
                return 'grid-container-1x1'
            } else {
                return 'grid-container-1x2'
            }
        }
        const getGridCellClass = () => {
            const secondaryValues = machine.secondaryValues;
            let numberValue = 0
            if (machine.mainValue != null) {
                numberValue++;
            }
            if (arrayIsSet(secondaryValues)) {
                numberValue += secondaryValues.length;
            }
            if (numberValue == 0) {
                return ''
            } else {
                return 'grid-' + numberValue
            }
        }
        const obj = {
            cardLayout,
            name,
            mainValue: machine.mainValue,
            gridClass: getGridContainerClass(),
            templateValues: {
                templateValues,
                cardLayout,
                mainValue: machine.mainValue,
                showButtomValue,
                secondaryValues: machine.secondaryValues,
                gridClass: getGridCellClass(),

            }
        }
        return obj
    }


    getErrorMachinePredicate(machine: MachineElement, getDate$: (date: Date) => Observable<string>, getTraduction: (value: string, params: KeyStringValue<string | undefined>) => string): Observable<{
        traduction: string,
        svgIcon: string
    } | undefined> {
        let errorMessages: string = '';
        if (arrayIsSet(machine.errorMessages())) {
            errorMessages = machine.errorMessages()!.reduce((prev, keyMessagges) => {
                if (prev == null) {
                    prev = ''
                }
                const traduction = getTraduction(keyMessagges, undefined as any)
                prev += traduction
                return prev;
            }, '' as string);
        }
        const today = new Date().getTime();
        const lastComm = isValidDate(machine.lastComm) ? machine.lastComm!.getTime() : new Date().getTime();
        const differenceWithNow = today - lastComm;
        const differenceH = Math.round(differenceWithNow / 1000 / 3600);
        if (differenceH > 2 || stringIsSet(errorMessages)) {
            // if(machine.info&&machine.info.)
            let svgIcon = differenceH > 2 ? 'disconnected' : 'alert_warning'
            return getDate$(machine.lastComm!).pipe(
                map(dateCast => {
                    return { traduction: getTraduction('errorPresent', { date: dateCast, errorMessages }), svgIcon }

                })
            )

        }
        return of(undefined)
    }

    getTraductionPredicate(secondaryValues: any, getDate$: (date: Date) => Observable<string>, getTraduction: (value: string, params: KeyStringValue<string | undefined>) => string, traductionSensorData: string | undefined): Observable<string> {
        const error = secondaryValues.error

        let errorMessages: string = '';
        if (error && error.traduction && error.traduction.key) {
            const getErrorMessages = () => {
                if (error.traduction.values && error.traduction.values.errorMessages) {
                    return error.traduction.values.errorMessages
                } else if (traductionSensorData) {
                    return traductionSensorData
                } else {
                    return ''
                }
            }
            if (error.traduction.values && error.traduction.values.date) {
                return getDate$(error.traduction.values.date).pipe(
                    map(dateCast => {
                        return getTraduction(error.traduction.key, {
                            date: dateCast,
                            errorMessages: getErrorMessages()
                        })

                    })
                )
            } else {
                errorMessages = getTraduction(error.traduction.key, { errorMessages: getErrorMessages() })
            }
        } else if (traductionSensorData) {
            errorMessages = traductionSensorData
        }
        return of(errorMessages)
    }

    getIconPredicate(secondaryValue: any, uom: string): { materialIcon?: string, svgIcon?: string } | undefined {
        if (secondaryValue.error) {
            return { svgIcon: secondaryValue.error.svgIcon, materialIcon: secondaryValue.error.icon }
        } else if (uom) {
            const getIcon = () => {
                if (['kWn ', 'V', 'A', 'kVA'].includes(uom)) {
                    return { materialIcon: 'elctric_bolt' }
                } else if (['kWth'].includes(uom)) {
                    return { svgIcon: 'flame' }
                } else {
                    return
                }
            }
            return getIcon()
        }
        return
    }

    protected readonly SENSORDATATYPETYPEVALUE = SENSORDATATYPETYPEVALUE;
    protected readonly Object = Object;
}
